import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import PageLayout from '../components/PageLayout';
import AnalyticsHub from '../components/AnalyticsHub';

const CalendarViewsAnalyticsPage: React.FC = () => {
  const { token } = useAuth();

  return (
    <PageLayout title="Calendar Views Analytics">
      <AnalyticsHub
        token={token}
        title="Region"
        metricType="region"
        showRegionColumn={false}
        blurb="Region popularity from calendar_view and venue_view rollups. Raw calendar-view Dynamo browsers are retired; use GA / CloudWatch / Athena for event-level detail."
      />
    </PageLayout>
  );
};

export default CalendarViewsAnalyticsPage;
